/* unplugin-vue-components disabled */import { render } from "./DueDateSettings.vue?vue&type=template&id=941e6b5c&scoped=true&ts=true"
import script from "./DueDateSettings.vue?vue&type=script&lang=ts"
export * from "./DueDateSettings.vue?vue&type=script&lang=ts"

import "./DueDateSettings.vue?vue&type=style&index=0&id=941e6b5c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-941e6b5c"]])

export default __exports__